import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "Acc-Page-Right-Nav" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_user_right_intro = _resolveComponent("app-user-right-intro")!
  const _component_app_business_right_nav = _resolveComponent("app-business-right-nav")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.user.type === 'talent')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_app_user_right_intro)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_app_business_right_nav)
        ])),
    _createVNode(_component_el_menu, {
      router: "",
      class: "Acc-Page-Right-Menu"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_menu_item, { index: "/account/account" }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createElementVNode("i", { class: "el-icon-lock" }, null, -1),
            _createElementVNode("span", null, "Account", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_el_menu_item, { index: "/account/profile" }, {
          default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
            _createElementVNode("i", { class: "el-icon-lock" }, null, -1),
            _createElementVNode("span", null, "Profile", -1)
          ]))]),
          _: 1
        }),
        false
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 0,
              index: "/account/settings"
            }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createElementVNode("i", { class: "el-icon-setting" }, null, -1),
                _createElementVNode("span", null, "Settings", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.user.type === 'founder')
          ? (_openBlock(), _createBlock(_component_el_menu_item, {
              key: 1,
              index: "/account/startups"
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createElementVNode("i", { class: "el-icon-office-building" }, null, -1),
                _createElementVNode("span", null, "Startups", -1)
              ]))]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}